export const setFromTargetValue = (setter) => (event) => setter(event.target.value);
